// extracted by mini-css-extract-plugin
export default {"card_details":"style_card_details__3S6MD"};